import {
  useState, useEffect,
} from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';
import {
  IResult,
} from './useUser.types';
import { getUserDetails } from './useUser.api';

function useUser(user?: CognitoUser): IResult {
  const [token, setToken] = useState<string>('');
  const [type, setType] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [supersetUser, setsupersetUser] = useState('');
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!user || !user.getSignInUserSession) return;
    const jwtToken = user?.getSignInUserSession()?.getIdToken()?.getJwtToken();
    if (jwtToken) {
      setToken(jwtToken);
    }
  }, [user]);

  useEffect(() => {
    if (!token) return;
    getUserDetails(token)
      .then((data) => {
        setName(data.data.name); setType(data.data.type); setsupersetUser(data.data.supersetUser); setUserName(data.data.userName);
        setEmail(data.data.authorizer_claims.email);
      });
  }, [token]);

  return {
    token, type, name, supersetUser, userName, email,
  };
}

export default useUser;
